import { Page, StyleSheet, Text, View } from "@react-pdf/renderer";
import React, { Fragment } from "react";
import { formatCurrency, isEmpty } from "../../../generalFunctions";
import { FIRM_NAME } from "../../../constants";
import dayjs from "dayjs";

const styles = StyleSheet.create({
  rowView: {
    flexDirection: "row",
    border: "1px solid #000",
    padding: 10,
    textAlign: "center",
    alignSelf: "flex-start",
    marginRight: 25,
  },
});

const AccountwiseRO = (props) => {
  let formattedData = [];
  let alreadyFilteredRos = [];

  const formatPartyBillData = (billData) => {
    let stringBillData = "";
    billData.forEach((bill, index) => {
      stringBillData =
        index === 0
          ? stringBillData + bill.partyBillId + " " + bill.partyBillAmount
          : stringBillData +
            "\n" +
            bill.partyBillId +
            " " +
            bill.partyBillAmount;
    });
    return stringBillData;
  };

  const formatPublicationBillData = (billData) => {
    let stringBillData = "";
    billData.forEach((bill, index) => {
      stringBillData =
        index === 0
          ? stringBillData +
            bill.pubBillId +
            " " +
            formatCurrency(bill.pubBillAmount)
          : stringBillData +
            "\n" +
            bill.pubBillId +
            " " +
            formatCurrency(bill.pubBillAmount);
    });
    return stringBillData;
  };

  props.data?.forEach((ro) => {
    if (!alreadyFilteredRos.includes(ro.roId)) {
      let roWithSameIds = props.data.filter((r) => r.roId === ro.roId);
      let currentRO = { ...roWithSameIds[0] };
      currentRO.partyBills = [];
      currentRO.publicationBills = [];
      let alreadyFilteredPartyBills = [],
        alreadyFilteredPublicationBills = [];
      roWithSameIds.forEach((filteredRo) => {
        if (
          filteredRo.partyBillId &&
          !alreadyFilteredPartyBills.includes(filteredRo.partyBillId)
        ) {
          currentRO.partyBills.push({
            partyBillId: filteredRo.partyBillId,
            partyBillAmount: formatCurrency(filteredRo.partyBillAmount),
          });
          alreadyFilteredPartyBills.push(filteredRo.partyBillId);
        }
        if (
          filteredRo.pubBillId &&
          !alreadyFilteredPublicationBills.includes(filteredRo.pubBillId)
        ) {
          currentRO.publicationBills.push({
            pubBillId: filteredRo.pubBillId,
            pubBillAmount: filteredRo.pubBillAmount,
          });
          alreadyFilteredPublicationBills.push(filteredRo.pubBillId);
        }
      });
      delete currentRO.partyBillId;
      delete currentRO.partyBillAmount;
      delete currentRO.pubBillId;
      delete currentRO.pubBillAmount;
      formattedData.push(currentRO);
      alreadyFilteredRos.push(ro.roId);
    }
  });

  formattedData?.forEach((element, index) => {
    element.srno = index + 1;
    element.dateOfInsertion =
      !isEmpty(element.dateOfInsertion) &&
      !element.dateOfInsertion.includes(",")
        ? dayjs(element.dateOfInsertion).format("DD-MM-YYYY")
        : element.dateOfInsertion.replace(/,/g, ",\n");
    element.ourBillnAmt = formatPartyBillData(element.partyBills);
    element.pubBillnAmt = formatPublicationBillData(element.publicationBills);
  });

  const tableData = {
    columnName: [
      "Sr No",
      "RO Id",
      "Client",
      "Publication",
      "RO Date",
      "Date Of Insertion",
      "Our Bill No. & Amt.",
      "Cmp Bill No. & Amt.",
    ],
    column: [
      "srno",
      "roId",
      "clientName",
      "publicationName",
      "roDate",
      "dateOfInsertion",
      "ourBillnAmt",
      "pubBillnAmt",
    ],
    alignHeader: [
      "left",
      "center",
      "center",
      "center",
      "center",
      "center",
      "center",
      "right",
    ],
    width: [5, 5, 14, 14, 8, 18, 18, 18],
    data: formattedData,
  };

  return (
    <Page style={{ padding: 15 }} id={formattedData.id} orientation="landscape">
      <Fragment>
        <View
          style={{
            flexDirection: "row",
            paddingBottom: 5,
            paddingTop: 7,
            alignSelf: "center",
          }}
        >
          <Text
            style={{
              fontSize: 16,
              flexDirection: "column",
              flexGrow: 1,
              marginBottom: 20,
            }}
          >
            Account Wise Release Orders
          </Text>
        </View>
        <View style={styles.rowView}>
          {tableData["columnName"].map((c, index) => (
            <Text
              key={index}
              style={{
                width: `${tableData["width"][index]}%`,
                fontSize: 9,
                textAlign: tableData["alignHeader"][index],
              }}
            >
              {c.toUpperCase()}
            </Text>
          ))}
        </View>
        {tableData["data"].map((rowData) => (
          <>
            <View style={styles.rowView}>
              {tableData["column"].map((c, index) => {
                return (
                  <Text
                    key={index}
                    style={{
                      width: `${tableData["width"][index]}%`,
                      fontSize: 9,
                    }}
                  >
                    {rowData[c]}
                  </Text>
                );
              })}
            </View>
          </>
        ))}
      </Fragment>
    </Page>
  );
};

export default AccountwiseRO;
